import React from "react";
import { EstadoHorario, FilaHorario, Problema } from "./interfaces";
import S from "./strings";

/** Estado del horario: En Curso en naranja suave, lo demás neutro. Verde queda solo para Matriculado. */
export const ChipEstado: React.FC<{ estado: EstadoHorario }> = ({ estado }) => (
	<span className={"hcChip" + (estado === "enCurso" ? " acento" : "")}>{S.estado[estado]}</span>
);

/** Problemas del horario como chips de oro cortos. En Revisar, «Nombre Distinto» enseña el nombre guardado. */
export const Problemas: React.FC<{ fila: FilaHorario; conNombre?: boolean }> = ({ fila, conNombre }) => {
	if (!fila.problemas || fila.problemas.length < 1) return null;
	return (
		<div className="hcChips">
			{fila.problemas.map((p: Problema) => (
				<React.Fragment key={p}>
					<span className="hcChip oro">{S.problema[p]}</span>
					{p === "nombreDistinto" && conNombre && fila.nombre ? <span className="hcGuardado">{fila.nombre}</span> : null}
				</React.Fragment>
			))}
		</div>
	);
};
